export default     {
    prompt:"Button Text Color?",
    field:"buttonTextColor",
    type:"childStyle",
    child:".e-button",
    valueType:"string",
    colorPicker:true,
    default:"inherit",
    property:"color"
}